import { render, staticRenderFns } from "./c1.vue?vue&type=template&id=4b31d3b9&scoped=true"
import script from "./c1.vue?vue&type=script&lang=js"
export * from "./c1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31d3b9",
  null
  
)

export default component.exports